import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase';

const USERS_COLLECTION = 'users';
const CONTACTS_COLLECTION = 'contacts';

// Get all internal users
export const getInternalUsers = async () => {
  try {
    const usersRef = collection(db, USERS_COLLECTION);
    const q = query(usersRef, where('isInternal', '==', true));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Error getting internal users:', error);
    throw error;
  }
};

// Get contacts for a specific account
export const getAccountContacts = async (accountId) => {
  try {
    const contactsRef = collection(db, CONTACTS_COLLECTION);
    const q = query(contactsRef, where('accountId', '==', accountId));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Error getting account contacts:', error);
    throw error;
  }
}; 